import * as moment from "moment";
import { Caracteristique } from "../../../../../../core/models/caracteristique/Caracteristique";
import { ValeurCaracteristique } from "../../../../../../core/models/valeur-caracteristique/ValeurCaracteristique";

class CaractDateController {
    caracteristique: Caracteristique;
    valeurs: ValeurCaracteristique[];
    model: ValeurCaracteristique;
    index: number;
    m: moment.Moment;
    defaultValue: String;
    /* @ngInject */
    constructor(moment: moment.Moment) {
        this.m = moment;
    }
    $onInit() {
        const value = this.valeurs.find(x => x.idCaracteristique === this.caracteristique.id);
        if (!value) {
            this.model = <ValeurCaracteristique>{
                id: 0,
                idCaracteristique: this.caracteristique.id,
                value: this.defaultValue || this.defaultValue === '0' ? this.defaultValue : null
            };
            this.valeurs.push(this.model);
        } else {
            this.model = value;
        }
    }
    $onDestroy() {}
}
export default {
    bindings: {
        caracteristique: '<',
        valeurs: '=',
        isObligatoire: '<',
        lecture: '<',
        defaultValue: '='
    },
    controller: CaractDateController,
    template: require('./caracteristique-date.html')
};
